import * as React from "react";
import type { SVGProps } from "react";
const SvgPresentation01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.2 11.4v-1.2m4.8 1.2V9m4.8 2.4V6.6m-7.2 9.6L7.8 21m8.794-.067-2.122-4.667M4.8 16.2a2.4 2.4 0 0 1-2.4-2.4V5.4A2.4 2.4 0 0 1 4.8 3h14.4a2.4 2.4 0 0 1 2.4 2.4v8.4a2.4 2.4 0 0 1-2.4 2.4z"
    />
  </svg>
);
export default SvgPresentation01;
